import { Box, Button, ButtonGroup, Text } from "@chakra-ui/react";
import React from "react";
import { Field, Form } from "react-final-form";
import { useTranslation } from "react-i18next";
import {
    AdaptedSelect,
    DropzoneControl,
    Optional,
    TextareaControl
} from "../components/Form";
import { Loader } from "../components/Loader";
import { LanguageCode, useLanguagesQuery } from "../graphql";

export interface IAccountProfileLanguageFormValues {
  languageCode: LanguageCode;
}

interface IAccountProfileLanguageForm {
  onSubmit: (values: IAccountProfileLanguageFormValues) => void;
  initialValues?: Optional<IAccountProfileLanguageFormValues>;
}

export const AccountProfileLanguageForm: React.FC<IAccountProfileLanguageForm> = React.memo(
    ({ onSubmit, initialValues }) => {
        const { t } = useTranslation();

        const validate = (values) => {
            const errors: { [key: string]: string } = {};

            if (!values.languageCode) {
                errors.languageCode = t("forms.requiredField");
            }

            return errors;
        };

        const { loading, data } = useLanguagesQuery({});

        const languages = data?.languages;

        if (loading) {
            return <Loader></Loader>;
        }

        return (
            <Form
                onSubmit={ onSubmit }
                validate={ validate }
                initialValues={ initialValues }
                render={ ({
                    handleSubmit,
                    form,
                    errors,
                    submitting,
                    pristine,
                    values
                }) => (
                    <Box as="form" p={ 2 } onSubmit={ handleSubmit }>
                        <Field
                            name="languageCode"
                            component={ AdaptedSelect }
                            label={ t("account.languageTab.title") }
                        >
                            { languages.map((item) => (
                                <option value={ item.code }>{ item.name }</option>
                            )) }
                        </Field>

                        <ButtonGroup spacing={ 4 }>
                            <Button
                                isLoading={ submitting }
                                loadingText={ t("forms.submitting") }
                                variantColor="teal"
                                type="submit"
                            >
                                { t("forms.save") }
                            </Button>
                            <Button
                                variantColor="teal"
                                variant="outline"
                                onClick={ form.reset }
                                isDisabled={ submitting || pristine }
                            >
                                { t("forms.clear") }
                            </Button>
                        </ButtonGroup>
                    </Box>
                ) }
            />
        );
    }
);
